<div class="hero min-h-80"
  style="background-image: url(https://voelas.dan-fisher.com/images/bg-breadcrumbs-01-1894x424.jpg);">
  <div class="hero-overlay bg-opacity-60"></div>
  <div class="hero-content text-center text-neutral-content">
    <div class="max-w-4xl">
      <h1 class="mb-1 lg:mb-3 text-2xl lg:text-5xl font-bold">Knowledge Shared is <span class="text-primary">Power Multiplied</span></h1>
      <h3 class="text-lg lg:text-xl font-light">Breaking Echo Chambers through Free Knowledge Sharing</h3>
    </div>
  </div>
</div>
<section class="">
  <div class="px-0 mx-auto">
    <div class="grid grid-cols-1 md:grid-cols-2">
      <div>
        <div class="max-w-md mx-auto px-5 py-10">
          <h3 class="text-3xl font-light mb-8 pb-8 contac-title">Let's <span
              class="text-primary font-semibold">Talk</span></h3>
          <form class="relative" [formGroup]="contactForm" [appSpinner]="isFormSaving" (ngSubmit)="onSubmit()">
            <div class="formgroup mb-3">
              <div class="label">
                <span class="label-text text-slate-400 require"> Name</span>
              </div>
              <input type="text" formControlName="name" placeholder="Enter your name"
                class="input input-bordered w-full max-w-md" />
              <app-validation-errors [submitted]="invalidForm" [control]="contactForm.get('name')">
              </app-validation-errors>
            </div>
            <div class="formgroup mb-3">
              <div class="label">
                <span class="label-text text-slate-400 require">Email</span>
              </div>
              <input type="email" formControlName="email" placeholder="Enter your email"
                class="input input-bordered w-full max-w-md" />
              <app-validation-errors [submitted]="invalidForm" [control]="contactForm.get('email')">
              </app-validation-errors>
            </div>
            <div class="formgroup mb-3">
              <div class="label">
                <span class="label-text require text-slate-400">Subject</span>
              </div>
              <input type="text" formControlName="subject" placeholder="Subject"
                class="input input-bordered w-full max-w-md" />
              <app-validation-errors [submitted]="invalidForm" [control]="contactForm.get('subject')">
              </app-validation-errors>
            </div>
            <div class="formgroup mb-2">
              <div class="label">
                <span class="label-text text-slate-400">Message</span>
              </div>
              <textarea formControlName="message" placeholder="Enter your message"
                class="textarea textarea-bordered textarea-sm w-full max-w-md"></textarea>
            </div>
            <button type="submit" [disabled]="!contactForm.valid"
              class="btn btn-primary w-full text-white mt-3">Send</button>
          </form>
          <ng-container *ngIf="isSubmitted">
            <div class=" text-primary p-2 text-center max-w-xl">
              <p>Your message has been sent successfully...! </p>
            </div>
          </ng-container>
        </div>
      </div>
      <div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d246.59238046957148!2d76.86082376890995!3d8.549940298273354!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xeeff56fc193aef81!2sFAYA+INNOVATIONS+PRIVATE+LIMITED!5e0!3m2!1sen!2sin!4v1528802385861"
          width="100%" height="375" frameborder="0" style="border:0" class="h-96 md:h-full" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</section>
